<div class="container">
    <anms-tenant-selector [tenantId]="tenantId" (tenantSelected)="tenantSelected($event)"></anms-tenant-selector>
    <anms-plant *ngIf="selectedTenant !== undefined" [tenantId]="selectedTenant?.id" [tenant]="selectedTenant" (plantSelected)="plantSelected($event)"></anms-plant>
</div>